// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"e7740fa3","712":"48d870a0","954":"df49ebb1"}[chunkId] + ".chunk.js";
};